<template lang="pug">
  v-data-table.elevation-1(:headers='headers' :items='categories' )
    template(v-slot:top)
      v-toolbar(flat='' color='white')
        v-toolbar-title Categorías
        v-divider.mx-4(inset='' vertical='')
        .flex-grow-1
        v-dialog(v-model='dialog' max-width='500px')
          template(v-slot:activator='{ on }')
            v-btn.mb-2(color='primary' dark='' v-on='on') Nuevo Categoría
          v-card
            v-card-title
              span.headline {{ formTitle }}
            v-card-text
              v-container
                v-row
                  input(type='hidden' v-model='editedItem.id')
                  v-col(cols='12' sm='6' md='4')
                    v-text-field(v-model='editedItem.name' label='Nombre')
                  v-col(cols='12' sm='6' md='4')
                    v-text-field(v-model='editedItem.desc' label='Descripción')
                  v-col(cols='12' sm='6' md='4')
                    v-select(:items='levels' ref='lvlSelect' item-text='name' item-value='id' v-model='editedItem.lvl_id' label='Level')
            v-card-actions
              .flex-grow-1
              v-btn(color='blue darken-1' text='' @click='close') Cancelar
              v-btn(color='blue darken-1' text='' @click='save') Guardar
    template(v-slot:item.action='{ item }')
      v-icon.mr-2(small='' @click='editItem(item)')
        | editar
      v-icon(small='' @click='deleteItem(item)')
        | borrar
    template(v-slot:no-data='')
      v-btn(color='primary' @click='initialize') Reset

</template> 

<script>

  import { config } from '../config.js'

  export default {
    data: () => ({
      dialog: false,
      loading: false,
      levels: [],
      headers: [
        {
          text: 'Categoría',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Descripción', value: 'desc', sortable: false },
        { text: 'Nivel', value: 'lvl', sortable: true },
        { text: 'Acciones', value: 'action', sortable: false }
      ],
      categories: [],
      editedIndex: -1,
      editedItem: {
        id: '',
        name: '',
        desc: '',
        updateDate: ''
      },
      defaultItem: {
        id:'',
        name: '',
        desc: '',
        updateDate: ''
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo registro' : 'Editar registro'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.$emit("loadingEvent", true);
      this.initialize()
    },

    methods: {
      initialize () {
        this.axios.get(`${config.serviceUri}catalogs?catalog=categories`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            this.categories = response.data.payload;
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.$emit("loadingEvent", false);
        });
        this.axios.get(`${config.serviceUri}catalogs?catalog=levels`)
        .then( (response) => {
            console.log('Succes request: ',response.data);
            this.levels = response.data.payload.sort(function (a, b) {
                            if (a.name > b.name) {
                              return 1;
                            }
                            if (a.name < b.name) {
                              return -1;
                            }
                            return 0;
                          });
            this.$emit("loadingEvent", false);
        })
        .catch( (error) => {
            console.log('Error: ', error);
            this.$emit("loadingEvent", false);
        });
      },

      editItem (item) {
        this.editedIndex = this.categories.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.categories.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.categories.splice(index, 1)
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        this.$emit("loadingEvent", true);
        if (this.editedIndex > -1) {
          Object.assign(this.categories[this.editedIndex], this.editedItem)
          
          let catalog =  {
              name: 'categories',
              data: this.editedItem
          }

          catalog.data.lvl = this.$refs.lvlSelect.selectedItems[0].name;

          if (catalog.data.id){
            this.axios.patch(`${config.serviceUri}catalogs?id=${catalog.data.id}`, catalog )
            .then( (response) => {
                console.log('Succes Creted: ',response.data);
                this.categories.push(catalog.data)
                this.$emit("loadingEvent", false);
            })
            .catch( (error) => {
                console.log('Error: ', error);
                this.$emit("loadingEvent", false);
            });
          }

        } else {
          console.log('New item');

          let catalog =  {
              name: 'categories',
              data: this.editedItem
          }

          catalog.data.lvl = this.$refs.lvlSelect.selectedItems[0].name;

          this.axios.post(`${config.serviceUri}catalogs`, catalog )
            .then( (response) => {
                console.log('Succes Creted: ',response.data);
                this.categories.push(catalog.data)
                this.$emit("loadingEvent", false);
            })
            .catch( (error) => {
                console.log('Error: ', error);
                this.$emit("loadingEvent", false);
            });
        }
        this.close()
      },
    },
  }
</script>
